<pagination-template #p='paginationApi'
                     (pageChange)='pageChange.emit($event)'
                     (pageBoundsCorrection)='pageBoundsCorrection.emit($event)'>
    <nav class='border-t border-gray-200 px-4 flex items-center justify-between sm:px-0'>
        <div class='-mt-px w-0 flex-1 flex'>
            <button
                (click)="p.previous()"
                [disabled]='p.isFirstPage()'
                [ngClass]='{ "text-gray-500 hover:text-gray-700 hover:border-gray-300": !p.isFirstPage(), "text-gray-200": p.isFirstPage() }'
                class='border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500'>
                <!-- Heroicon name: solid/arrow-narrow-left -->
                <svg class='mr-3 h-5 w-5' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'
                     fill='currentColor' aria-hidden='true'>
                    <path fill-rule='evenodd'
                          d='M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z'
                          clip-rule='evenodd' />
                </svg>
                Previous
            </button>
        </div>
        <div class='hidden md:-mt-px md:flex'>
            <button
               *ngFor='let page of p.pages'
               (click)="p.setCurrent(page.value)"
               [ngClass]='{
        "border-primary-500 text-primary-600": p.getCurrent() === page.value,
        "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300": p.getCurrent() !== page.value
       }'
               class='border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'>
                {{ page.label }}
            </button>
        </div>
        <div class='-mt-px w-0 flex-1 flex justify-end'>
            <button
                (click)="p.next()"
                [disabled]='p.isLastPage()'
                [ngClass]='{ "text-gray-500 hover:text-gray-700 hover:border-gray-300": !p.isLastPage(), "text-gray-200": p.isLastPage() }'
               class='border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium'>
                Next
                <!-- Heroicon name: solid/arrow-narrow-right -->
                <svg class='ml-3 h-5 w-5 text-gray-400' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'
                     fill='currentColor' aria-hidden='true'>
                    <path fill-rule='evenodd'
                          d='M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z'
                          clip-rule='evenodd' />
                </svg>
            </button>
        </div>
    </nav>
</pagination-template>
